import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  StreamNotificationsParams
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary Notification SSE stream
 */
export const streamNotifications = (
    params: StreamNotificationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/notifications/stream`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getStreamNotificationsQueryKey = (params: StreamNotificationsParams,) => {
    return [`https://api.ugot.uk/api/notifications/stream`, ...(params ? [params]: [])] as const;
    }

    
export const getStreamNotificationsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof streamNotifications>>, TError = AxiosError<void>>(params: StreamNotificationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamNotifications>>> = ({ signal }) => streamNotifications(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof streamNotifications>>>
export type StreamNotificationsInfiniteQueryError = AxiosError<void>

/**
 * @summary Notification SSE stream
 */
export const useStreamNotificationsInfinite = <TData = Awaited<ReturnType<typeof streamNotifications>>, TError = AxiosError<void>>(
 params: StreamNotificationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getStreamNotificationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getStreamNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof streamNotifications>>, TError = AxiosError<void>>(params: StreamNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamNotifications>>> = ({ signal }) => streamNotifications(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type StreamNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof streamNotifications>>>
export type StreamNotificationsQueryError = AxiosError<void>

/**
 * @summary Notification SSE stream
 */
export const useStreamNotifications = <TData = Awaited<ReturnType<typeof streamNotifications>>, TError = AxiosError<void>>(
 params: StreamNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getStreamNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



